<ion-header>
  <ion-toolbar>
    <ion-row style="align-items: center">
      <ion-col size="1" style="display: flex">
        <ion-buttons>
          <ion-icon class="backButton" name="arrow-back-sharp" (click)="router.navigate(['/home'])"></ion-icon>
        </ion-buttons>
      </ion-col>
      <ion-col size="9" style="text-align: start">
        <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
          <ion-searchbar formControlName="searchQuery" (ionBlur)="onSearch()" placeholder="Search Patient"
            showCancelButton="never" (ionClear)="clearSearch()"></ion-searchbar>
        </form>
      </ion-col>
      <ion-col size="1">
        <ion-row style="display: flex; justify-content: space-evenly">
          <img src="/assets/imges/translate.png" (click)="openLangPopover($event)" alt="Translate Icon"
            style="width: 30px; height: 30px; cursor: pointer" />
        </ion-row>
      </ion-col>
      <ion-col size="1">
        <ion-row style="display: flex; justify-content: space-evenly">
          <img src="/assets/imges/header/user.svg" (click)="openPopover($event)" alt="Icon 3"
            style="width: 35px; height: 35px" />
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-header>
<ion-popover #userPopover [isOpen]="isUserPopoverOpen" [event]="popoverEvent" (didDismiss)="isUserPopoverOpen = false"
  side="bottom" alignment="end">
  <ng-template>
    <ion-list style="min-width: 150px">
      <ion-item class="cursor-pointer" lines="none" (click)="fallbackToLoggedInUser()">
        <ion-label class="ion-text-wrap">{{userDetails?.name}}</ion-label>
      </ion-item>
      <ion-item button (click)="logout()" lines="none">
        <ion-label color="danger">Logout</ion-label>
      </ion-item>
    </ion-list>
  </ng-template>
</ion-popover>

<ion-popover #langPopover [isOpen]="isLangPopoverOpen" [event]="langPopoverEvent"
  (didDismiss)="isLangPopoverOpen = false" side="bottom" alignment="end">

  <ng-template>
    <ion-list style="min-width: 150px">
      <ion-item button (click)="changeLanguage('en')" lines="none">
        <ion-label>English</ion-label>
      </ion-item>

      <ion-item button (click)="changeLanguage('mar')" lines="none">
        <ion-label>मराठी (Marathi)</ion-label>
      </ion-item>
    </ion-list>
  </ng-template>
</ion-popover>